import React from 'react';
import { TripForm } from '../trip-form/trip-form.component';
import { RoutesComponent } from '../routes-component/routes.componet';
import { BoardingPointsComponent } from '../boarding-points/boarding-points.root.component';
import { DropPointsComponent } from '../drop-points/drop-points.root.component';

export const renderMenuContent = (key, formData, updateformData) => {
  switch (key) {

    case "tripDetails": return <TripForm formData={formData} updateformData={updateformData} />;
    case "routeDetails": return <RoutesComponent formData={formData} />;
    case "boardingDetails": return <BoardingPointsComponent />;
    case "dropDetails": return <DropPointsComponent />;

    default: return <h1>No project match</h1>
  }
}
